import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Delete,
  Visibility,
  Download,
  PagesRounded,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";

function History(props) {
  const [quotationList, setQuotationList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  // const isRsm =
  //   userProfile?.user_role[0]?.roleName === "Regional Sales Manager";
  // const isCeo =
  //   userProfile?.user_role[0]?.roleName === "Chief Executive Officer";

  // const isCfo =
  //   userProfile?.user_role[0]?.roleName === "Chief Financial Officer";

  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Regional_Sales_Manager_permissions"
  );
  const isCeo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Executive_Officer_permissions"
  );
  const isCfo = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Chief_Financial_Officer_permissions"
  );

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Name",
      selector: (row) => row.username,
    },
    {
      name: "Order Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-yyyy"),
    },
    {
      name: "Order Time",
      selector: (row) => moment(row.createdAt).format("HH:mm:ss"),
    },
    {
      name: "Order No",
      selector: (row) => row?.order_no,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
  ];

  useEffect(() => {
    console.log("Vieewww effect called");
    getOrderList();
  }, [page]);

  const getOrderList = () => {
    var bodyFormData = new FormData();
    console.log("Api called");
    // bodyFormData.append("order_by", userProfile?.id);
    //   bodyFormData.append("id", props?.rowData?.id);

    utils
      .callAPI(
        "get",
        `sales/order/history/${
          isRsm || isCeo || isCfo
            ? props?.rowData?.order_id
            : props?.rowData?.id
        }`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          console.log("Here is the res", res.result);
          setQuotationList(res);
        } else {
          setQuotationList([]);
        }
      })
      .catch((err) => {
        setQuotationList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "History",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getDelete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getOrderList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {/* Timeline Component */}
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h6 className="card-title">History</h6>
                    {console.log(props?.rowData)}
                    <div id="content">
                      {quotationList?.length > 0 ? (
                        <ul className="timeline">
                          {quotationList?.map((order, index) => (
                            <li
                              className="event"
                              key={index}
                              data-date={moment(order.createdAt).format(
                                "DD-MM-yyyy - hh:mm A"
                              )}
                            >
                              <p>{order.type}</p>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-center">No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default History;
